import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { EventBus } from '@/helpers/EventBusHelper';
import { EventBusEvents } from '@/enums/global/EventBusEvents';
import HelpPage from '@/shared/components/HelpPage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CalculatorTopBar',
  props: {
    pathBefore: null,
    pathCurrent: null,
    showSubmitButton: { type: Boolean },
    disableSubmitButton: { type: Boolean },
    submitButtonText: null,
    showCancelButton: { type: Boolean },
    cancelButtonText: null,
    cancelButtonEvent: null
  },
  setup(__props: any) {

const props = __props as {
    pathBefore?: string;
    pathCurrent: string;
    showSubmitButton?: boolean;
    disableSubmitButton: boolean;
    submitButtonText?: string;
    showCancelButton?: boolean;
    cancelButtonText?: string;
    cancelButtonEvent?: EventBusEvents;
};



const isButtonAnimated = ref(true);

const submitOnClick = async () => {
    EventBus.$emit(EventBusEvents.calculatorCreateProject, true);
};

const cancelOnClick = (): void => {
    EventBus.$emit(props.cancelButtonEvent as EventBusEvents);
};

setTimeout(() => {
    isButtonAnimated.value = false;
}, 20000);

return { __sfc: true,props, isButtonAnimated, submitOnClick, cancelOnClick, HelpPage }
}

})